import { Routes } from '@angular/router';
import { PROJECT_NAME } from '@shared/global/globals';

export const AUTH_ROUTES: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./login/login-page').then((m) => m.LoginPage),
    title: `Login - ${PROJECT_NAME}`,
  },
  {
    path: 'password-reset',
    loadComponent: () =>
      import('./password-reset/password-reset-page').then((m) => m.PasswordResetPage),
    title: `Password Reset - ${PROJECT_NAME}`,
  },
];

/**
 * White-label entry point: the same login page, rendered by a public shell
 * branch that declares the Jetcrete brand (see `app.routes.ts`).
 */
export const JETCRETE_AUTH_ROUTES: Routes = [
  {
    path: 'jetcrete-login',
    loadComponent: () => import('./login/login-page').then((m) => m.LoginPage),
    title: `Jetcrete Login - ${PROJECT_NAME}`,
  },
];
